import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CiCircleInfo } from "react-icons/ci";
import Loader from "../Components/Loader";
import OrderCancellationDialog from "../Components/ordertrackingcomponents/DialogCancelOrder";
import ProductDrawer from "../Components/productListcomponents/ProductDrawer";
import { showErrorToast } from "../utils/toaster";
import { baseurl } from "../config/url";

export default function OrderTracking() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  // Function to handle closing the dialog
  const handleCloseDialog = () => {
    setIsDialogOpen(false); // Hide the dialog
  };
  const [statusFilter, setStatusFilter] = useState("all");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredOrders, setFilteredOrders] = useState([]); // Filtered orders state
  const [expanded, setExpanded] = useState(null); // Track only one expanded order
  const [openDrawer, setOpenDrawer] = useState(false); // Drawer open/close state
  const [selectedProduct, setSelectedProduct] = useState(null); // To hold selected product details
  const [selectedtracking, setselectedtracking] = useState("");
  const [selectedproductQuantity, setselectedproductQuantity] = useState(0)
  const [status, setstatus] = useState("")
  const fetchOrders = async () => {
    let userId = localStorage.getItem("userId");
    if (!userId) {
      showErrorToast("User ID not found in local storage");
      setLoading(false);
      return;
    }
    // Retrieve token from localStorage
    const token = localStorage.getItem("token");
    if (!token) {
      showErrorToast("Authentication token not found");
      setLoading(false);
      return;
    }
    try {
      // Include token in headers
      const response = await axios.get(
        `${baseurl}/api/order/get-user-order/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass token in the Authorization header
          },
        }
      );

      setOrders(response?.data || []);
      setFilteredOrders(response?.data || []);
    } catch (err) {
      console.error("Error fetching orders:", err);
      showErrorToast("Failed to fetch orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleExpandClick = (orderId) => {
    setExpanded((prevExpanded) => (prevExpanded === orderId ? null : orderId)); // Collapse if already expanded
  };

  // Open the drawer and set the selected product
  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setOpenDrawer(true);
  };

  // Function to get stage color based on status
  const getStageColor = (status) => {
    switch (status) {
      case "Pending":
        return "bg-gray-400";
      case "Confirmed":
        return "bg-blue-400";
      case "Shipped":
        return "bg-yellow-400";
      case "Delivered":
        return "bg-green-400";
      case "Cancelled":
        return "bg-red-400";
      default:
        return "bg-gray-300";
    }
  };

  // Apply filters
  const applyFilters = () => {
    let tempordersdata = JSON.parse(JSON.stringify(orders));
    let filterdata = tempordersdata.map((order) => {
      let trackingarray = [];
      order.tracking.filter((track) => {
        let result =
          track.statusUpdates[
            track.statusUpdates.length - 1
          ].status.toLowerCase() == statusFilter.toLowerCase();
        if (result || statusFilter.toLowerCase() == "all")
          trackingarray.push(track);
      });
      order.tracking = trackingarray;
      return order;
    });
    setFilteredOrders(filterdata);
  };

  return (
    <div className="flex min-h-screen bg-gray-50 p-4 gap-4">
      {/* Filters Sidebar */}
      <div className="w-64 bg-white p-4 rounded-lg shadow-sm h-fit">
        <h2 className="font-medium mb-4 text-left">Filters</h2>
        <div className="space-y-4">
          <div>
            <label className="text-sm text-gray-600 mb-1 block">
              Order Status
            </label>
            <select
              className="w-full border rounded-lg px-3 py-2 text-sm text-gray-700 focus:ring focus:ring-blue-500 focus:outline-none"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="all">All</option>
              <option value="pending">Pending</option>
              <option value="confirmed">Confirmed</option>
              <option value="shipped">Shipped</option>
              <option value="delivered">Delivered</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>
          <button
            onClick={applyFilters} // Apply filters on button click
            className="w-full bg-blue-600 text-white font-medium py-2 rounded-lg hover:bg-blue-700"
          >
            Apply Filters
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 bg-white rounded-lg shadow-sm p-6">
        <h1 className="text-xl font-semibold mb-6">Track Your Orders</h1>
        {loading ? (
          <Loader />
        ) : (
          <div className="space-y-4">
            {filteredOrders.length != 0 &&
              filteredOrders.some((order) => order.tracking.length > 0) ? (
              filteredOrders.map((order) => {
                return order.tracking.map((trackingorder) => {
                  return (
                    <div key={order._id} className="border rounded-lg p-4">
                      <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2">
                          <span className="font-medium">
                            Order ID: {trackingorder?._id}
                          </span>
                        </div>
                        <div className="flex items-center gap-4">
                          <span className="text-sm text-gray-500">
                            {trackingorder.statusUpdates[0].timestamp
                              ? dayjs(
                                trackingorder.statusUpdates[0].timestamp
                              ).format("DD-MMM-YYYY")
                              : "NA"}
                          </span>
                          <button
                            onClick={() => handleExpandClick(trackingorder._id)}
                            className="text-blue-500 hover:text-blue-700"
                          >
                            {expanded === trackingorder._id ? "-" : "+"}
                          </button>
                        </div>
                      </div>

                      <div className="space-y-3 mt-4">
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">Status:</span>
                          <span>
                            {trackingorder.statusUpdates &&
                              trackingorder.statusUpdates.length > 0
                              ? trackingorder.statusUpdates[
                                trackingorder.statusUpdates.length - 1
                              ].status
                              : "No status available"}
                          </span>
                        </div>

                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">Product :</span>
                          <div className="flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleProductClick(trackingorder.statusUpdates[0]?.productId || {})
                              }
                              aria-label="info"
                            >
                              <CiCircleInfo fontSize={"20px"} />
                            </button>
                            <span>{trackingorder.statusUpdates[0]?.productId?.name || "N/A"}</span>

                          </div>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">Quantity :</span>
                          <div className="flex items-center gap-2">
                            <span>
                              {order.items.find(
                                (pr) =>
                                  pr.product === trackingorder.statusUpdates[0]?.productId?._id
                              )?.quantity || "NA"}
                            </span>

                          </div>
                        </div>

                        {expanded === trackingorder._id && (
                          <div className="space-y-4 mt-4">
                            {[
                              "Pending",
                              "Confirmed",
                              "Shipped",
                              "Delivered",
                              "Cancelled",
                            ].map((stage) => {
                              const stageUpdate =
                                trackingorder.statusUpdates.find(
                                  (update) => update.status === stage
                                );
                              return (
                                <div
                                  key={stage}
                                  className={`flex justify-between items-center ${stageUpdate
                                    ? "rounded"
                                    : "text-sm text-gray-400"
                                    }`}
                                >
                                  <div className="flex items-center gap-2">
                                    <div
                                      className={`w-2 h-2 rounded-full ${stageUpdate
                                        ? getStageColor(stage)
                                        : "bg-gray-300"
                                        }`}
                                    ></div>
                                    <span className="text-sm">{stage}</span>
                                    {/* Show reason if status is 'Cancelled' */}
                                    {stage === "Cancelled" && stageUpdate?.reason && (
                                      <div className="text-sm text-red-500 ml-2">
                                        <strong>Reason:</strong> {stageUpdate?.reason}
                                      </div>
                                    )}
                                  </div>
                                  <span className="text-sm text-gray-500">
                                    {stageUpdate
                                      ? new Date(
                                        stageUpdate.timestamp
                                      ).toLocaleString()
                                      : "N/A"}
                                  </span>
                                </div>
                              );
                            })}

                            {/* Show Cancel Order button before "Shipped" */}
                            {["Pending", "Confirmed"].includes(
                              trackingorder.statusUpdates[
                                trackingorder.statusUpdates.length - 1
                              ].status
                            ) && (
                                <div
                                  className="text-red-500 flex justify-end font-medium text-sm cursor-pointer hover:underline"
                                  onClick={() => {
                                    setIsDialogOpen(true);
                                    setselectedtracking(trackingorder);
                                    setSelectedProduct(trackingorder.statusUpdates[0].productId)
                                    // Find the product quantity safely
                                    const productQuantity =
                                      order?.items?.find(
                                        (pr) => pr.product === trackingorder.statusUpdates?.[0]?.productId?._id
                                      )?.quantity || 0;

                                    setselectedproductQuantity(productQuantity);
                                  }}
                                >
                                  Cancel Order
                                </div>
                              )}
                          </div>
                        )}

                        <div className="flex justify-between items-center bg-gray-50 p-3 rounded-lg">
                          <div className="flex items-center gap-2">
                            <div
                              className={`w-2 h-2 rounded-full ${trackingorder.statusUpdates[0].status ===
                                "shipped"
                                ? "bg-blue-400"
                                : "bg-gray-400"
                                }`}
                            ></div>
                            <span className="text-sm">
                              {trackingorder.statusUpdates &&
                                trackingorder.statusUpdates.length > 0
                                ? trackingorder.statusUpdates[
                                  trackingorder.statusUpdates.length - 1
                                ].status
                                : "No status available"}
                            </span>
                          </div>
                          <p className="text-sm text-green-600">
                            Expected Delivery Date:{" "}
                            {trackingorder.dispatchDetails?.expectedDeliveryDate
                              ? dayjs(
                                trackingorder.dispatchDetails
                                  .expectedDeliveryDate
                              ).format("DD-MMM-YYYY") // Adjust the format as needed
                              : "NA"}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                });
              })
            ) : (
              <div className="text-center text-gray-500 mt-10">
                No data found
              </div>
            )}
          </div>
        )}
      </div>
      <ProductDrawer
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
        selectedProduct={selectedProduct}
      />
      <OrderCancellationDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        fetchOrders={fetchOrders}
        selectedtracking={selectedtracking}
        selectedProduct={selectedProduct}
        selectedproductQuantity={selectedproductQuantity}
      />
    </div>
  );
}
